import React, {Fragment} from 'react';
import {translate} from "react-i18next";
import SupporterApi from "../../../apis/SupporterApi";
import moment from "moment";
import EventBus from "../../../helpers/EventBus";
import {connect} from "react-redux";
import {createNumberMask} from "text-mask-addons";
import MaskedInput from "react-text-mask";
import swal from "sweetalert";
import {getSupporterProject} from "../../../actions/supporterProjectAction";
import SwapTicketToasterIdentifier from "./SwapTicketToasterIdentifier";
import SetTicketToasterIdentifier from "./SetTicketToasterIdentifier";

class Ticket extends React.Component {
  state = {
    loading: true,
    loadingPayout: false,
    ticketData: null,
    payoutOpen: false,
    payoutAmount: '210',
    donationAmount: '',
  };

  componentDidMount() {
    this.loadData();
    EventBus.on('SupporterTicketBlock-load', this.loadData);
  }

  componentWillUnmount() {
    EventBus.remove('SupporterTicketBlock-load', this.loadData);
  }

  startPayout = () => {
    this.setState({
      payoutOpen: true,
      donationAmount: ''
    })
  }

  cancelPayout = () => {
    this.setState({
      payoutOpen: false,
      donationAmount: ''
    })
  }

  loadData = () => {
    this.setState({loading: true});
    SupporterApi.getTicketForSupporterProject(this.props.supporterId)
      .then((response) => {
        if (response.status === 200 && response.data.success === true) {
          this.setState({
            ticketData: response.data.data,
            loading: false,
          })
        }
      })
  }

  handleCreatePayout = (e) => {
    e.preventDefault();
    if (this.state.donationAmount && this.state.donationAmount.length > 0 && parseInt(this.state.donationAmount) > 210) {
      alert('Spendenbetrag zu hoch!');
      return;
    }
    this.setState({loadingPayout: true});
    SupporterApi.createPayoutForSupporterProject(this.props.supporterId, this.state.payoutAmount, this.state.donationAmount)
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            loadingPayout: false
          });
          if (response.data.success === true) {
            this.setState({
              ticketData: response.data.data,
            })
            swal({
              title: 'Check-Out erfolgreich',
              text: 'Der Check-Out inkl. Auszahlung war erfolgreich!',
              icon: 'success'
            }).then();
            this.props.dispatch(getSupporterProject(response.data.data.supporterId));
          } else {
            swal({
              title: 'Check-Out-Fehler',
              text: 'Leider ist ein Fehler aufgetreten. Bitte wende dich im Rocket-Chat an die IT.',
              icon: 'error'
            }).then();
          }
        }
      })
  }

  renderTicketStatus = (ticket) => {
    const {t} = this.props;
    let text;
    let color;
    if (ticket.invalidated) {
      text = t('supporterProject.ticket.statusCode.invalidated');
      color = "danger"
    } else if (ticket.checkedIn) {
      text = t('supporterProject.ticket.statusCode.checkedIn');
      color = "success";
    } else if (ticket.ticketType === 'PRETIX' && ticket.pretixStatus !== "p") {
      text = t('supporterProject.ticket.statusCode.created');
      color = "secondary";
    } else {
      text = t('supporterProject.ticket.statusCode.valid');
      color = "primary";
    }
    return <span className={`text-${color}`}>{text}</span>;
  }

  render() {
    const {t, supporterProject} = this.props;
    const {ticketData} = this.state;

    if (!supporterProject) return null;

    return (
      <div className="Ticket ibox">
        <div className="ibox-title">
          <h5>{t('supporterProject.ticket.title')}</h5>
          <div className="ibox-tools">
            <a onClick={this.loadData}>
              <i className="fa fa-refresh"/>
            </a>
          </div>
        </div>
        <div className="ibox-title">
          {this.state.loading ? (
              <div className="text-center">
                <i className="fa fa-3x fa-spin fa-spinner"/>
              </div>
            ) : (
              ticketData ? (
                ticketData.status === 'noTicket' ? (
                  <div>{t('supporterProject.ticket.noTicket')}</div>
                ) : (
                  <div>
                    <table className="table table-sm table-bordered">
                      <tbody>
                      <tr>
                        <td>
                          {t('supporterProject.ticket.number')}
                        </td>
                        <th>
                          {ticketData.ticket.number}
                        </th>
                      </tr>
                      <tr>
                        <td>
                          {t('supporterProject.ticket.ticketType')}
                        </td>
                        <th>
                          {ticketData.ticket.ticketType}
                        </th>
                      </tr>
                      <tr>
                        <td>
                          {t('supporterProject.ticket.createdAt')}
                        </td>
                        <th>
                          {ticketData.ticket.createdAt ? moment(ticketData.ticket.createdAt).format('DD.MM.YYYY HH:mm') : null}
                        </th>
                      </tr>
                      <tr>
                        <td>
                          {t('supporterProject.ticket.status')}
                        </td>
                        <th>
                          {this.renderTicketStatus(ticketData.ticket)}
                        </th>
                      </tr>
                      {ticketData.ticket.invalidated ? (
                        <tr>
                          <td>
                            {t('supporterProject.ticket.invalidatedAt')}
                          </td>
                          <th>
                            {ticketData.ticket.invalidatedAt ? moment(ticketData.ticket.invalidatedAt).format('DD.MM.YYYY HH:mm') : null}
                          </th>
                        </tr>
                      ) : null}
                      {ticketData.ticket.checkedIn ? (
                        <Fragment>
                          <tr>
                            <td>
                              {t('supporterProject.ticket.checkedInAt')}
                            </td>
                            <th>
                              {ticketData.ticket.checkedInAt ? moment(ticketData.ticket.checkedInAt).format('DD.MM.YYYY HH:mm') : null}
                            </th>
                          </tr>
                          <tr>
                            <td>
                              Bändsel ID
                            </td>
                            <th>
                              {ticketData.ticket.ticketToasterIdentifier ? ticketData.ticket.ticketToasterIdentifier : null}
                            </th>
                          </tr>
                        </Fragment>
                      ) : null}
                      {ticketData.ticket.ticketType === "PRETIX" ? (
                        <Fragment>
                          <tr>
                            <td>
                              {t('supporterProject.ticket.url')}
                            </td>
                            <th>
                              <a href={ticketData.ticket.externalReference4} target="_blank" rel="noopener noreferrer">
                                {t('supporterProject.ticket.urlLink')}
                              </a>
                            </th>
                          </tr>
                          <tr>
                            <td>
                              {t('supporterProject.ticket.pretixStatus')}
                            </td>
                            <th>
                              {t(`supporterProject.ticket.pretixStatusCode.${ticketData.ticket.pretixStatus}`)}
                            </th>
                          </tr>
                          <tr>
                            <td>
                              {t('supporterProject.ticket.pretixPaymentProvider')}
                            </td>
                            <th>
                              {ticketData.ticket.pretixPaymentProvider}
                            </th>
                          </tr>
                        </Fragment>
                      ) : null}
                      </tbody>
                    </table>
                    {ticketData.ticket.pretixPayoutAt ? (
                      <div>
                        <b>Auszahlung ist bereits erfolgt</b>
                        <table className="table table-sm table-bordered">
                          <tbody>
                          <tr>
                            <td>
                              Datum
                            </td>
                            <th>
                              {moment(ticketData.ticket.pretixPayoutAt).format('DD.MM.YY HH:mm')}
                            </th>
                          </tr>
                          <tr>
                            <td>
                              Auszahlungsbetrag
                            </td>
                            <th>
                              {ticketData.ticket.pretixPayoutAmount}
                            </th>
                          </tr>
                          <tr>
                            <td>
                              Spendenbetrag
                            </td>
                            <th>
                              {ticketData.ticket.pretixDonationAmount}
                            </th>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    ) : !this.props.readOnly && supporterProject.state && supporterProject.checkOut && supporterProject.state === 'CHECKED_IN' && ticketData.ticket.pretixPaymentProvider !== 'free' && ticketData.ticket.payoutPossible ? (
                      <div>
                        <b>
                          Auszahlung erstellen
                        </b>
                        {this.state.payoutOpen ? (
                          <form onSubmit={this.handleCreatePayout} style={{marginTop: '10px'}}>
                          <div className="form-group">
                            <label>
                              Auszahlungsbetrag
                            </label>
                            <input className="form-control" type="text" value={this.state.payoutAmount} readOnly={true} onChange={e => this.setState({payoutAmount: e.target.value})}/>
                          </div>
                          <div className="form-group">
                            <label>
                              Spendenbetrag
                            </label>
                            <MaskedInput className="form-control" type="text" name="donationAmount"
                                         mask={createNumberMask({
                                           prefix: '',
                                           includeThousandsSeparator: false,
                                           integerLimit: 3
                                         })}
                                         value={this.state.donationAmount}
                                         onChange={(e) => this.setState({donationAmount: e.target.value})}/>
                          </div>
                          <div className="btn-group">
                            <button type="button" className="btn btn-default" disabled={this.state.loading} onClick={this.cancelPayout}>
                              Abbrechen
                            </button>
                            <button type="submit" className="btn btn-primary" disabled={this.state.loading}>
                              Auszahlung erstellen
                            </button>
                          </div>
                          {this.state.loadingPayout ? (
                            <p>Die Auszahlung wird erstellt, bitte warten...</p>
                          ) : null}
                        </form>) : (
                          <button className="btn btn-danger" onClick={this.startPayout} type="button" style={{marginTop: '10px'}}>
                            Supporter:in auschecken und Auszahlung erstellen
                          </button>
                          )}
                      </div>
                    ) : (
                    <div>
                      <b>
                        Für den/die Supporter:in ist keine Auszahlung möglich.
                      </b>
                    </div>
                    )}
                    {ticketData.ticket.ticketToasterIdentifier ? (
                      <div className="m-t-lg m-b">
                        <SwapTicketToasterIdentifier supporterId={this.props.supporterId}/>
                      </div>
                    ) : (
                      ticketData.allowSetTicketToasterIdentifierManually ? (
                        <div className="m-t-lg m-b">
                          <SetTicketToasterIdentifier supporterId={this.props.supporterId}/>
                        </div>
                      ) : null
                    )}
                  </div>
                )
              ) : (
                <div>
                  {t('supporterProject.ticket.dataError')}
                </div>
              )
            )
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  supporterProject: state.supporterProject
});

export default connect(mapStateToProps, null)(translate()(Ticket));